import Command from '@ckeditor/ckeditor5-core/src/command'

export default class FullscreenCommand extends Command {
    execute(){
        // let contentChildren = $(this.editor.sourceElement).find(` ~ .ck-editor .ck-content`)[0].children;    
        // let previewTab = window.open(location.href.replace('web/edit','preview'),'_blank');
        // $(contentChildren).each(function(index){ previewTab.document.writeln(this.outerHTML) });
        // previewTab.document.close();

        // let contentChildren = $(this.editor.sourceElement).find(` ~ .ck-editor .ck-content`)[0].children;    
        // let previewTab = window.open(location.href.replace('web/edit','preview'),'_blank');
        // previewTab.transferChildren = Array.from(contentChildren);

        const editorHTML = $(this.editor.ui.view.element);
        console.log(`SHOULD EXECUTE FULLSCREEN COMMAND`,editorHTML);
        if(editorHTML.hasClass('ck-fullscreen')){
            editorHTML.removeClass('ck-fullscreen');
        }else{
            editorHTML.addClass('ck-fullscreen');
        };
    }
}